import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from 'shared/directives/tooltip.directive';

@Component({
    selector: 'app-translated-text-renderer',
    imports: [TranslateModule, TooltipDirective],
    templateUrl: './translated-text-renderer.component.html',
    styleUrl: './translated-text-renderer.component.scss',
})
export class TranslatedTextRendererComponent implements ICellRendererAngularComp {
    tooltipMessage: string | undefined;
    translationParams: Record<string, any> = {};
    autoTooltip: boolean = false;
    protected useFormattedValue: boolean = false;

    @Input() set displayValue(value: string) {
        this._displayValue = value;
    }

    get displayValue(): string {
        return this._displayValue;
    }

    @Input() isFloatingFilterIcon?: boolean = false;

    private _displayValue: string = '';

    agInit(
        params: ICellRendererParams & {
            tooltipMessage?: string;
            useFormattedValue?: boolean;
            translationParams?: Record<string, any>;
            autoTooltip?: boolean;
        },
    ): void {
        this.useFormattedValue = params.useFormattedValue ?? false;
        this.displayValue = this.useFormattedValue ? params.valueFormatted : params.value;
        this.translationParams = params.translationParams ?? {};
        this.autoTooltip = params.autoTooltip ?? false;
        this.tooltipMessage = params.tooltipMessage;
    }

    refresh(): boolean {
        return false;
    }
}
